"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _AaPlatform = _interopRequireDefault(require("../../../utils/AaPlatform"));

var _styles = _interopRequireDefault(require("./styles"));

var BannerMobileHeader = function BannerMobileHeader(props) {
  var image = props.image,
      onClose = props.onClose;
  var iconName = _AaPlatform["default"].IS_IOS ? _crossPlatformComponents.AaIconTypes.ARROW_RIGHT_WHITE : _crossPlatformComponents.AaIconTypes.NAV_BACK_WHITE_ICON;
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.ImageBackground, {
    source: image,
    style: _styles["default"].headerImage
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableWithoutFeedback, {
    onPress: onClose
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: _styles["default"].headerBackButton
  }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaIconComponent, {
    controls: {
      iconName: iconName,
      iconStyle: _styles["default"].bannerIcon
    }
  }))));
};

var _default = BannerMobileHeader;
exports["default"] = _default;